<img src="assets/img/close.png" class="close" (click)="close()" />

<div class="modal-body">
  <img src="assets/img/{{icon}}.png" class="dialog-icon" />
  <div class="row" [ngClass]="{ 'im3' : platform === 'im3', 'indosat' : platform === 'indosat' || platform === 'tri' }">
    <b class="col-12 dialog-title" [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat' || platform === 'tri' }">
      {{ "dialog." + dialogType + ".title" | translate }}
    </b>
    <b class="col-12 dialog-text"> {{ "dialog." + dialogType + ".content" | translate }}
    </b>
    <div class="col-12">
      <a class="btn btn-action" (click)="doAction()">
        {{ "dialog." + dialogType + ".btn_1" | translate }}
      </a>
    </div>
    <div class="col-12" *ngIf="dialogType === 'update_warning' ">
      <a class="btn btn-cancel" (click)="close()">
        {{ "dialog." + dialogType + ".btn_2" | translate }}
      </a>
    </div>
  </div>
</div>